import React from "react";
function RMIndexComponent() {
  return (
    <div>
      <div>Student RMIndex</div>
    </div>
  );
}
export default RMIndexComponent;
